"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cond = void 0;
const condp_1 = require("./condp");
const errors_1 = require("./utils/errors");
const identity_1 = require("./utils/identity");
function cond(...args) {
    // changes here nead to be mirrored in cond
    try {
        return condp_1.condp(identity_1.identity, null, ...args);
    }
    catch (e) {
        if (e instanceof errors_1.IllegalArgumentException)
            return null;
        throw e;
    }
}
exports.cond = cond;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jb25kLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUErQjtBQUUvQiwyQ0FBeUQ7QUFDekQsK0NBQTRDO0FBcUM1QyxTQUFnQixJQUFJLENBQUMsR0FBRyxJQUFTO0lBQzdCLDJDQUEyQztJQUMzQyxJQUFJO1FBQ0EsT0FBTyxhQUFLLENBQUMsbUJBQVEsRUFBRSxJQUFJLEVBQUUsR0FBRyxJQUFJLENBQUMsQ0FBQTtLQUN4QztJQUFDLE9BQU8sQ0FBQyxFQUFFO1FBQ1IsSUFBSSxDQUFDLFlBQVksaUNBQXdCO1lBQUUsT0FBTyxJQUFJLENBQUM7UUFDdkQsTUFBTSxDQUFDLENBQUM7S0FDWDtBQUNMLENBQUM7QUFSRCxvQkFRQyJ9